export const getAddress = async (cep: string) => {
  try {
    const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
    const data = await response.json();
    if (data.erro) {
      return { city: "", state: "" };
    }
    return {
      city: data.localidade,
      state: data.uf,
    };
  } catch (error) {
    console.error("Error fetching CEP:", error);
    return { city: "", state: "" };
  }
};
